// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__qDaS2","main":"Layout_main__zDs6d","backButton":"Layout_backButton__tXFlX"};